<template>
  <div class="venue-analysis-details">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4">
            <div class="top-navbar-left">
              <div class="btn-back" @click="$router.go(-1)">
                <font-awesome-icon :icon="['fas', 'angle-left']" />
                Back
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-center">Full Detail Map</div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-right">
              <!--                            <button class="btn btn-ecdc">Export Report</button>-->
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="row">
        <transition name="fade" mode="out-in">
          <div id="side-filter-col" class="col-lg-3">
            <div class="side-filter">
              <div class="title">
                Filter
              </div>

              <div class="form-group">
                <div class="label">Area</div>
                <div class="custom-modal-select" v-b-modal.area-modal>
                  <input type="button" class="form-control" value="Select" />
                </div>

                <div class="selected-label" v-if="filter.area.length > 0">
                  FILTER:
                  <div v-for="area in filter.area" :key="area">
                    {{ areaOptions.find((x) => x.id === area).name }}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="label">Category</div>
                <app-multi-select
                  :options="
                    categoryOptions.map((categoryOption) => categoryOption.id)
                  "
                  :custom-label="
                    (opt) => categoryOptions.find((x) => x.id === opt).category
                  "
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :preselect-first="false"
                  :placeholder="'-- All Category --'"
                  v-model="filter.category"
                >
                  <template
                    slot="selection"
                    slot-scope="{ values, search, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length &amp;&amp; !isOpen"
                      >{{ values.length }} selected</span
                    ></template
                  >
                </app-multi-select>

                <div class="selected-label" v-if="filter.category.length > 0">
                  FILTER:
                  <div v-for="category in filter.category" :key="category">
                    {{
                      categoryOptions.find((x) => x.id === category).category
                    }}
                  </div>
                </div>
              </div>

              <div class="filter-action">
                <button
                  type="button"
                  class="btn btn-ecdc btn-block"
                  @click="setFilter"
                >
                  Apply
                </button>
                <button
                  type="button"
                  class="btn btn-link btn-block text-light"
                  @click="clearFilter"
                >
                  Clear Filter
                </button>
              </div>
            </div>
          </div>
        </transition>

        <div id="table-content-col" class="col-lg-9">
          <div id="cdcMap"></div>
        </div>
      </div>
    </div>

    <b-modal id="area-modal" hide-header hide-footer centered size="xl">
      <img
        src="../assets/img/icon-close.png"
        alt="icon-close"
        class="img-fluid modal-close"
        @click="$bvModal.hide('area-modal')"
      />

      <div class="selection-modal">
        <h4 class="title text-left mb-5">Area</h4>

        <div class="form-group">
          <div class="row">
            <div
              v-for="area in areaOptions"
              v-bind:key="area.id"
              class="col-4 col-xl-2"
            >
              <div class="custom-control custom-checkbox form-check-inline">
                <input
                  class="custom-control-input"
                  type="checkbox"
                  :id="'inlineCheckbox' + area.id"
                  :value="area.id"
                  v-model="filter.area"
                />
                <label
                  class="custom-control-label"
                  :for="'inlineCheckbox' + area.id"
                  >{{ area.name }}</label
                >
              </div>
            </div>
          </div>
        </div>

        <div>
          <button
            type="button"
            class="btn btn-ecdc"
            @click="$bvModal.hide('area-modal')"
          >
            Done
          </button>
          <button
            type="button"
            class="btn btn-link text-muted"
            @click="clearArea()"
          >
            Clear Selection
          </button>
        </div>
      </div>
    </b-modal>

    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<script>
import Loader from "./Loader.vue";
import Multiselect from "vue-multiselect";
import {
  getAreas,
  getVenueAnalysisCategories,
  getVenuesMap,
} from "../api";

export default {
  components: {
    appLoader: Loader,
    appMultiSelect: Multiselect,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMAGE_BASE_URL,
      filter: {
        area: [],
        category: [],
      },
      areas: [],
      areaOptions: [],
      categories: [],
      categoryOptions: [],
      isLoading: false,
      toggleFilter: true,
      styledMapType: "",
      map: "",
      venues: "",
      venueArray: [],
    };
  },
  async mounted() {
    await this.getAreas();
    await this.getVenueAnalysisCategories();
    // await this.getVenuesMap();
    await this.initMap();
    this.isLoading = false;
  },
  methods: {
    async initMap() {
      this.styledMapType = new window.google.maps.StyledMapType(
        JSON.parse(process.env.VUE_APP_MAP),
        { name: "Styled Map" }
      );

      // const centerLatLng = {
      //   lat: parseFloat("-0.789300"),
      //   lng: parseFloat("113.921300"),
      // };

      var sanFrancisco = new window.google.maps.LatLng(37.774546, -122.433523);

      this.map = new window.google.maps.Map(document.getElementById("cdcMap"), {
        center: sanFrancisco,
        zoom: 13,
        mapTypeId: 'satellite',       
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
      });
      this.map.mapTypes.set("styled_map", this.styledMapType);
      this.map.setMapTypeId("styled_map");

      /* Data points defined as an array of LatLng objects */
      var heatmapData = [
        new window.google.maps.LatLng(37.782, -122.447),
        new window.google.maps.LatLng(37.782, -122.445),
        new window.google.maps.LatLng(37.782, -122.443),
        new window.google.maps.LatLng(37.782, -122.441),
        new window.google.maps.LatLng(37.782, -122.439),
        new window.google.maps.LatLng(37.782, -122.437),
        new window.google.maps.LatLng(37.782, -122.435),
        new window.google.maps.LatLng(37.785, -122.447),
        new window.google.maps.LatLng(37.785, -122.445),
        new window.google.maps.LatLng(37.785, -122.443),
        new window.google.maps.LatLng(37.785, -122.441),
        new window.google.maps.LatLng(37.785, -122.439),
        new window.google.maps.LatLng(37.785, -122.437),
        new window.google.maps.LatLng(37.785, -122.435)
      ];

      var heatmapData1 = [
        new window.google.maps.LatLng(37.782, -122.447),
        new window.google.maps.LatLng(37.782, -122.445),
        new window.google.maps.LatLng(37.782, -122.443),
        new window.google.maps.LatLng(37.782, -122.441),
        new window.google.maps.LatLng(37.782, -122.439),
        new window.google.maps.LatLng(37.782, -122.437),
        new window.google.maps.LatLng(37.782, -122.435),
        new window.google.maps.LatLng(37.785, -122.447),
        new window.google.maps.LatLng(37.785, -122.445),
        new window.google.maps.LatLng(37.785, -122.443),
        new window.google.maps.LatLng(37.785, -122.441),
        new window.google.maps.LatLng(37.785, -122.439),
        new window.google.maps.LatLng(37.785, -122.437),
        new window.google.maps.LatLng(37.785, -122.435)
      ];

      var heatmap = new window.google.maps.visualization.HeatmapLayer({
        data: heatmapData
      });

      var heatmap1 = new window.google.maps.visualization.HeatmapLayer({
        data: heatmapData1
      });

      var gradient = [
        'rgba(0, 255, 255, 0)',
        'rgba(0, 255, 255, 1)',
        'rgba(0, 191, 255, 1)',
        'rgba(0, 127, 255, 1)',
        'rgba(0, 63, 255, 1)',
        'rgba(0, 0, 255, 1)',
        'rgba(0, 0, 223, 1)',
        'rgba(0, 0, 191, 1)',
        'rgba(0, 0, 159, 1)',
        'rgba(0, 0, 127, 1)',
        'rgba(63, 0, 91, 1)',
        'rgba(127, 0, 63, 1)',
        'rgba(191, 0, 31, 1)',
        'rgba(255, 0, 0, 1)'
      ];

      heatmap1.set('gradient', heatmap.get('gradient') ? null : gradient);
      heatmap1.setMap(this.map);
      heatmap.setMap(this.map);
    },
    async getVenueAnalysisCategories() {
      try {
        const result = await getVenueAnalysisCategories();
        this.categories = result.data.categories;
        this.categoryOptions = this.categories;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getAreas() {
      try {
        const result = await getAreas();
        this.areas = result.data.data;
        this.areaOptions = this.areas;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getVenuesMap() {
      this.venueArray = [];

      try {
        const result = await getVenuesMap(this.filter);
        this.venues = result.data.venues;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    clearFilter() {
      this.filter.area = [];
      this.filter.category = [];
    },
    async setFilter() {
      this.isLoading = true;
      await this.getVenuesMap();
      this.isLoading = false;
    },
    clearArea() {
      this.filter.area = [];
    },
  },
};
</script>

<style scoped>
#cdcMap {
  width: 100%;
  height: 800px;
}
</style>
